import {
  Trans,
  useTranslation,
  useValidationTextField,
} from '@zurich/common/hooks';
import { appsVSGADataNames } from '@zurich/test/testdatanames';
import { Typography } from '@zurich/ui/atoms';
import { TextField } from '@zurich/ui/legacy/components';
import { StepLayout } from '~/components/Steps/StepLayout';
import { licensePlateVSGALiveSchema } from '~/lib/schemas';
import {
  licensePlateFieldSelector,
  licensePlateValidationSelector,
} from '~/state';

export function LicensePlate() {
  const {
    helperText: licensePlateHelperText,
    onChange,
    ...licensePlateFieldProps
  } = useValidationTextField({
    atom: licensePlateFieldSelector,
    validationSelector: licensePlateValidationSelector,
    fieldName: 'licensePlate',
    i18nPrefix: 'vsga:fields.',
    yupSchema: licensePlateVSGALiveSchema,
    required: true,
    trim: true,
  });

  const { t } = useTranslation();

  return (
    <StepLayout
      illustration="/images/vsga/kennzeichen-icon.svg"
      alt={t('vsga:licensePlate.title')}
    >
      <Typography variant="body2 light" color="darkBlue">
        <Trans
          i18nKey="vsga:licensePlate.body"
          components={{ strong: <strong /> }}
        />
      </Typography>
      <TextField
        {...licensePlateFieldProps}
        onChange={(e) => {
          e.target.value = e.target.value.toUpperCase();
          onChange(e);
        }}
        dataName={appsVSGADataNames.licensePlate}
        helperText={licensePlateHelperText}
      />
    </StepLayout>
  );
}
